import { InMemoryCache } from '@apollo/client';

export function createApolloCache(): InMemoryCache {
  return new InMemoryCache({
    typePolicies: {
      PreferenceSelection: {
        keyFields: false,
      },
      RepossessionModalClient: {
        keyFields: ['id', 'value', 'previousValue'],
      },
      RDNCase: {
        keyFields: ['caseId'],
      },
      Collateral: {
        keyFields: ['vin'],
      },
      ComparisonFloatType: {
        merge: false,
      },
      ClientListLienholders: {
        keyFields: [
          'id',
          'targetRecoveryRate',
          'assignments',
          ['current', 'previous'],
          'repossessions',
          ['current', 'previous'],
          'missedRepossessions',
          ['current', 'previous'],
          'recoveryRates',
          ['current', 'previous'],
        ],
      },
      CaseAssignee: {
        keyFields: false,
      },
    },
  });
}
